import React from 'react';
import type { FormikValues } from 'formik';

import NonViewCommunicationCardHeaderContactDetails from '~/components/communications/CommunicationCard/NonViewCommunicationCardHeaderContactDetails';
import SelectDirectionFormik from '~/components/communications/CommunicationCard/SelectDirectionFormik';
import ViewCommunicationCardHeaderContactDetails from '~/components/communications/CommunicationCard/ViewCommunicationCardHeaderContactDetails';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';
import { reportErrorInProductionOrThrow } from '~/Utils';
import cn from '~/Utils/cn';

import type { ChannelType, Direction } from './constants';

interface CommunicationCardHeaderProps {
  communicationId?: number;
  communicationClaimId?: number;
  channel: ChannelType;
  direction?: Direction;
  contactId?: number;
  contactFullName?: string;
  contactRole?: string;
  isDynamicContact?: boolean;
  onSelectContact?: (contact: ContactFullModel) => void;
  getValuesOnSelectContact?: (contact: ContactFullModel | '', valuesWithContact: FormikValues) => FormikValues;
  dynamicContactLabel?: string;
  isView?: boolean;
  outOfContactsContextSearch?: boolean;
  onCommunicationUpdate?: () => void;
}

const CommunicationCardHeader: React.FC<CommunicationCardHeaderProps> = ({
  communicationId,
  channel,
  direction,
  contactId,
  contactFullName,
  contactRole,
  isDynamicContact,
  onSelectContact,
  getValuesOnSelectContact,
  dynamicContactLabel,
  isView,
  communicationClaimId,
  onCommunicationUpdate,
  outOfContactsContextSearch = false,
}) => {
  if (isView && !communicationId) {
    reportErrorInProductionOrThrow('CommunicationCardHeader: communicationId is required in view mode');
    return null;
  }

  return (
    <>
      {!direction && <SelectDirectionFormik />}
      <div className={cn('flex items-center', 'mb-12')}>
        {isView && communicationId ? (
          <ViewCommunicationCardHeaderContactDetails
            communicationId={communicationId}
            communicationClaimId={communicationClaimId}
            communicationChannel={channel}
            contactId={contactId}
            contactFullName={contactFullName}
            contactRole={contactRole}
            enableAttachToContact={!contactId && !!communicationClaimId}
            onAttachToContact={onCommunicationUpdate}
          />
        ) : (
          <NonViewCommunicationCardHeaderContactDetails
            enableChoosingContact={isDynamicContact}
            contactId={contactId}
            contactFullName={contactFullName}
            contactRole={contactRole}
            onSelectContact={onSelectContact}
            getValuesOnSelectContact={getValuesOnSelectContact}
            outOfContactsContextSearch={outOfContactsContextSearch}
            dynamicContactLabel={dynamicContactLabel}
          />
        )}
      </div>
    </>
  );
};

export default CommunicationCardHeader;
